import React from 'react';

import {Text, Anchor} from '@albert-io/atomic';

export default function TermsFooter() {
  return (
    <Text size='xs' color='tertiary' className='w-full text-center'>
      By signing up for Albert, you agree to our{' '}
      <Anchor href='/terms-of-use' className='content-tertiary underline'>
        Terms of Use
      </Anchor>{' '}
      and{' '}
      <Anchor href='/privacy' className='content-tertiary underline'>
        Privacy Policy
      </Anchor>
      .
    </Text>
  );
}
